/**
 * GENERATED FILE -- DO NOT HAND-EDIT
 * Source:     packages/permissions-registry/permissions.json
 * Regenerate: npm run permissions:sync   (offline -- no DB/VPN needed)
 */
export enum SitePermissions {
  Admin = 1,
  AdminUser = 2,
  AdminPermission = 3,
  AdminPermissionArea = 4,
  AdminPermissionProfile = 53,
  SignUpEdit = 54,
  IqaCreateRecord = 55,
  IqaDeleteRecord = 56,
  IqaUpdateRecord = 57,
  IqaDeleteRequest = 58,
  EventAudit = 59,
  EventCreate = 60,
  EventEdit = 61,
  EventDelete = 62,
  AttendanceEditFinancePaid = 63,
  // Converged (#1266): was C# EmployerContactCreate / TS ContactCreate. This is the one case where
  // the "DB label wins" rule and accuracy conflicted (see the registry README). The live
  // [UI].[PERMISSION].Name label for id 64 was "Create Contact", which is TERSER than reality —
  // every call site is employer-scoped (EmployerController.CreateEmployerContact; the frontend
  // employer-overview contact card). Rather than adopt the vaguer name, BOTH ends were fixed: the
  // code takes the accurate C# form and the DB label is updated to "Create Employer Contact" by the
  // SQL in the PR body. The UPDATE is cosmetic and is NOT a deploy blocker — runtime reconciliation
  // compares ids only and never reads Name. Name-only change — the id, the [UI].[PERMISSION] row and
  // its DB_STAFF_PERMISSION grants are untouched.
  EmployerContactCreate = 64,
  // Converged (#1266): was C# EmployerContactEdit / TS ContactEdit. Same resolution as id 64 — the
  // live [UI].[PERMISSION].Name label was "Edit Contact", terser than the employer-scoped reality
  // (EmployerController.UpdateEmployerContact), so the code takes the accurate C# form and the DB
  // label is updated to "Edit Employer Contact" by the SQL in the PR body. Cosmetic, not a deploy
  // blocker. Name-only change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants
  // are untouched.
  EmployerContactEdit = 65,
  // Converged (#1266): was C# EmployerContactDelete / TS ContactDelete. Same resolution as id 64 —
  // the live [UI].[PERMISSION].Name label was "Delete Contact", terser than the employer-scoped
  // reality (EmployerController.DeleteEmployerContact), so the code takes the accurate C# form and
  // the DB label is updated to "Delete Employer Contact" by the SQL in the PR body. Cosmetic, not a
  // deploy blocker. Name-only change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION
  // grants are untouched.
  EmployerContactDelete = 66,
  EmployerEventCreate = 67,
  EmployerEventEdit = 68,
  EmployerEventDelete = 69,
  EmployerHealthAndSafetyEdit = 70,
  BdHomepageView = 71,
  CmHomepageView = 72,
  ContractManagementContractInfo = 73,
  ContractManagementSupportCosts = 74,
  ContractManagementPaymentHistory = 75,
  ContractManagementFinancialInformation = 76,
  EmployerCreate = 77,
  LearnerJgwProgressStatusEdit = 78,
  ContractManagementUpdateFreezeData = 79,
  MarketingHomepageView = 80,
  HsHomepageView = 81,
  ReportsView = 82,
  EmployerEditStatus = 83,
  EmployerEditRoot = 84,
  EmployerEditDetails = 85,
  EmployerCreateMaytasLinks = 86,
  EmployerDeleteMaytasLinks = 87,
  AdminAcwExport = 88,
  LearnerTargetCompletionDateEdit = 89,
  PartnerHomepageView = 115,
  ProgressDeleteRegRequest = 118,
  AttendanceApprovalSelectAll = 119,
  // Converged (#1266): was C# AuthorisedAbsenceSelectAll / TS AttendanceAuthorisedAbsenceSelectAll.
  // The live [UI].[PERMISSION].Name label for id 120 is "Select All Authorised Absence" — it carries
  // no "Attendance" prefix, so the C# form wins and the DB label decides (see the registry README).
  // Name-only change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants are untouched.
  AuthorisedAbsenceSelectAll = 120,
  AttendanceRemoveCurrentWeek = 121,
  AttendanceRemoveTwoWeeks = 122,
  AttendanceRemoveAllTime = 123,
  AttendanceEditCurrentWeek = 125,
  AttendanceEditTwoWeeks = 126,
  AttendanceEditAllTime = 127,
  DataDashboardHomepage = 128,
  DataDashboardCount = 129,
  DataDashboardIALP = 130,
  DataDashboardAttainment = 131,
  DataDashboardLearnerProgress = 132,
  ProgressAddObjectiveNote = 133,
  AttendanceCreateTwoWeeks = 135,
  AttendanceCreateAllTime = 136,
  // Converged (#1266): was showSafeguarding in BOTH languages — camelCase, anomalous for an enum
  // member. Not a C#/TS split, a pure casing fix. The live [UI].[PERMISSION].Name label for id 137 is
  // "Show Safeguarding", whose PascalCase form is exactly this identifier, so no SQL is needed.
  // Name-only change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants are
  // untouched. (The learner-details component field `showSafeguarding` is a separate local flag and
  // keeps its camelCase name.)
  ShowSafeguarding = 137,
  AttendanceMovePotCurrentWeek = 139,
  AttendanceMovePotAllTime = 140,
  // Converged (#1266): was editEsq in BOTH languages — camelCase, anomalous for an enum member. Not
  // a C#/TS split, a pure casing fix of the EXISTING identifier rather than a re-derivation from the
  // live [UI].[PERMISSION].Name label ("Edit ESQ"), so the .NET convention for a three-letter acronym
  // applies and the member is EditEsq, NOT EditESQ. Contrast id 142 BDStartsTracker, where the
  // two-letter acronym correctly stays upper and the convention and the DB label agree. No SQL is
  // needed. Name-only change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants
  // are untouched. (The learner-details component field and the learner-esq @Input() `editEsq` are
  // separate local bindings and keep their camelCase names.)
  EditEsq = 141,
  // Converged (#1266): was C# BDStartsTracker / TS bdStartsTracker (camelCase, anomalous for an
  // enum member). The live [UI].[PERMISSION].Name label for id 142 is "BD Starts Tracker", so the
  // C# form wins and the DB label decides (see the registry README). Not to be confused with the
  // unrelated BdStartsTracker *report* identifiers (ReportVariant 79 / VmBdStartsTracker). Name-only
  // change — the id, the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants are untouched.
  BDStartsTracker = 142,
  // Converged (#1266): was C# MaytasLinkByLearner / TS MaytasLinkPage. The live
  // [UI].[PERMISSION].Name label for id 145 is "Maytas Link Page", and the DB label wins
  // when the two languages disagree (see the registry README). Name-only change — the id,
  // the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants are untouched.
  MaytasLinkPage = 145,
  /**
   * @deprecated #1502 — retired as the import-tool gate, split into the five per-import
   * permissions (152–156). Retained ONLY as the grant-backfill source on live; do not use
   * it to gate any route, tile or endpoint. Mirrors C# Permission.AdminWorkshopCalendarImport.
   *
   * Converged (#1266): was C# AdminWorkshopCalendarImport / TS ImportTool. The live
   * [UI].[PERMISSION].Name label for id 146 is literally "AdminWorkshopCalendarImport", so the
   * C# form wins and the DB label decides (see the registry README). Name-only change — the id,
   * the [UI].[PERMISSION] row and its DB_STAFF_PERMISSION grants are untouched, and the member
   * stays deprecated.
   */
  AdminWorkshopCalendarImport = 146,
  AdminHolidayCarryover = 149,
  // AdminLearningAimEditor enforcement has shipped and the Id is pinned to 150 (locked by the
  // enum<->DB id contract test; mirrored in C# Permission.AdminLearningAimEditor). Go-live
  // prerequisite: the live [UI].[PERMISSION] row must exist with Id = 150 and be granted to
  // everyone who currently sees the Learning Aim editor (Widget 16), or those users will 403 —
  // captured in the PR's "SQL to run on live" section for a human to run.
  AdminLearningAimEditor = 150,
  // AdminIqaProfileWhitelistEditor (issue #1394) is pinned to 151, mirroring C#
  // Permission.AdminIqaProfileWhitelistEditor. A C#-side unit test
  // (IqaProfileWhitelistPermissionTests) asserts the enum literal is 151 and collision-free, but no
  // test can resolve the live [UI].[PERMISSION] row offline (it is data-only / MAX(Id)+1 on insert).
  // ⚠️ A human MUST verify before go-live that 151 is the next free live id and grant it to the
  // intended group, or authorised users will 403 — captured in the PR's "SQL to run on live"
  // section for a human to run. The route guard is fail-open without data.permission, so the route
  // entry MUST carry it (asserted by a route-guard spec).
  AdminIqaProfileWhitelistEditor = 151,
  // Per-import permissions for the admin Import Tool (issue #1502), mirroring C#
  // Permission.AdminImport* (152–156). Each replaces the shared AdminWorkshopCalendarImport (146) on
  // its endpoint; the
  // import-tool page/tile now gate on "any of these five" and each button shows only with its own
  // permission. Pinned + collision-checked C#-side by ImportToolPermissionTests.
  // ⚠️ A human MUST verify before go-live that 152–156 are the next free live [UI].[PERMISSION] ids and
  // BACKFILL grants from AdminWorkshopCalendarImport (146) to all five, or current import users will
  // 403 — captured in
  // the PR's "SQL to run on live" section.
  AdminImportWorkshopBooking = 152,
  AdminImportWorkshopCreate = 153,
  AdminImportAttendance = 154,
  AdminImportEvents = 155,
  AdminImportIqaProfiles = 156,
  // ViewAuthAudit (audit programme S1, issue #1572) mirrors C# Permission.ViewAuthAudit and gates
  // reading the auth/access audit trail. Emitted here by the #1266 registry (both enums are identical
  // supersets of permissions.json); nothing in the frontend consumes it yet — the audit viewer UI
  // lands in a later phase. Pinned + collision-checked C#-side by ViewAuthAuditPermissionTests.
  // ⚠️ A human MUST verify before go-live that 157 is the next free live [UI].[PERMISSION] id and
  // grant it only to the confirmed compliance/DPO staff — captured in the PR's "SQL to run on live"
  // section.
  ViewAuthAudit = 157,
  // Search-term REVEAL gate (audit S4), mirroring C# Permission.ViewSearchReveal = 158. The C# literal is the
  // enforcing gate ([PermissionRequired] on the SearchReveal endpoint); this mirror only shows/hides the "Reveal
  // search details" affordance. Deliberately SEPARATE from (and narrower than) 157 — holding 157 shows the PII-free
  // trail, but revealing a raw search term/filters is a materially more sensitive act.
  // ⚠️ A human MUST verify before go-live that 158 is the next free live [UI].[PERMISSION] id and grant it ONLY to
  // the narrow reveal group — captured in the PR's "SQL to run on live" section. Also enable
  // Audit:EnableAuditReadEmission before granting, or reveals fail closed (503).
  ViewSearchReveal = 158,
  // Report-parameter REVEAL gate (audit S4, report analogue), mirroring C# Permission.ViewReportParameterReveal = 159.
  // The C# literal is the enforcing gate; this mirror only shows/hides the "Reveal report filters" affordance. Separate
  // from 158 so report-filter reveal and search-term reveal can be granted to different groups.
  // ⚠️ A human MUST verify 159 is the next-free live [UI].[PERMISSION] id and grant it ONLY to the narrow report-reveal
  // group — captured in the PR's "SQL to run on live" section. Enable Audit:EnableAuditReadEmission before granting.
  ViewReportParameterReveal = 159,
  // Entity field-VALUE REVEAL gate (E0 — entity field-value capture), mirroring C# Permission.ViewEntityFieldValues = 160.
  // The C# literal is the enforcing gate; this mirror only shows/hides the "Reveal values" affordance. Separate from 157
  // so reading the flag-only "which fields changed" (157) and decrypting the actual old/new values (160) can be granted
  // to different groups.
  // ⚠️ A human MUST verify 160 is the next-free live [UI].[PERMISSION] id and grant it ONLY to the narrow dev/admin group
  // — captured in the PR's "SQL to run on live" section. DPIA-gated.
  ViewEntityFieldValues = 160,
  // Essential Skills support-needs EDIT gate, mirroring C# Permission.EditEssentialSkillsNeeds = 161. The C# literal
  // is the enforcing gate; this mirror only reveals the edit affordance (the pencil) on the learner card.
  // ⚠️ A human MUST verify 161 is the next-free live [UI].[PERMISSION] id and INSERT the row at exactly 161 — captured
  // in the PR's "SQL to run on live" section.
  EditEssentialSkillsNeeds = 161,
  // Essential Skills support-needs bulk-IMPORT gate, mirroring C# Permission.AdminImportEssentialSkillsNeeds = 162.
  // Separate from 161 so the spreadsheet import can be granted to a smaller admin group than day-to-day editing.
  // ⚠️ A human MUST verify 162 is the next-free live [UI].[PERMISSION] id and INSERT the row at exactly 162 — captured
  // in the PR's "SQL to run on live" section.
  AdminImportEssentialSkillsNeeds = 162,
  // Subject-erasure gate (audit #1653 — right-to-erasure), mirroring C# Permission.EraseAuditSubject = 163. The C#
  // literal is the enforcing gate ([PermissionRequired] on the erasure endpoint, fail-closed); nothing in the frontend
  // consumes it yet (there is no erasure UI). Emitted here by the #1266 registry (both enums are identical supersets).
  // ⚠️ A human MUST verify before go-live that 163 is the next-free live [UI].[PERMISSION] id and grant it ONLY to the
  // DPO/compliance erasure-operator role — captured in the PR's "SQL to run on live" section. DPIA-gated.
  EraseAuditSubject = 163,
  // High Risk report gate (#1674), mirroring C# Permission.HighRiskReport = 164. The C# literal is the
  // enforcing gate ([PermissionRequired] on both the data and filter endpoints). Nothing in the frontend
  // reads this mirror: the reporting menu comes from the database (UI.PERMISSION.Name joined to
  // UI.REPORT.TITLE). It exists so the registry sync check sees the two enums agree.
  // ⚠️ A human MUST verify 164 is the next-free live [UI].[PERMISSION] id, INSERT the row at exactly 164,
  // and set [UI].[REPORT].PERMISSIONID = 164 for REPORTID 84 - captured in the PR's "SQL to run on live"
  // section.
  HighRiskReport = 164,
  // Learner pay EXPORT gate (#1536), mirroring C# Permission.LearnerPayExport = 165. The C# literal is the enforcing
  // gate ([PermissionRequired] on the five pay-export routes). Nothing in the frontend reads this mirror: the export
  // dialog shows the server's refusal. It exists so the registry sync check sees the two enums agree. Separate from
  // AttendanceEditFinancePaid (63, the card's Import) so that holding 63 does not unlock the bank files.
  // ⚠️ A human MUST verify 165 is free on live and INSERT the row at exactly 165 — see
  // .project-files/release-sql/issue-1536-learner-pay-export-permission.sql.
  LearnerPayExport = 165,
  All = null,
}
